import SectionArticles from './SectionArticles';

export default SectionArticles;
